
import rtHeaderButtonGroup from "./rtHeaderButtonGroup";
import rtInput from "./rtInput";

let components = [
  //rt
  {
    name: rtHeaderButtonGroup.name,
    component: rtHeaderButtonGroup
  },
  {
    name: rtInput.name,
    component: rtInput
  }
];

export default components;


// WEBPACK FOOTER //
// ./src/components/index.js